export default __webpack_public_path__ + "static/cope_hero-cd84bd7c46a9c12ae0dd671d5d6d6515.jpg";